<template>
  <div v-if="customStyleLoaded" class="h-100">
    <tenant-custom-style :css-string="customStyle"></tenant-custom-style>
    <component :is="layout"></component>
    <b-modal v-if="!supportedBrowser" ref="browserNotSupportedWarningModal" size="lg" centered hide-footer>
      <template slot="modal-title">
        <span class="warning">{{ i18n.browserNotSupportedWarning.title }}</span>
      </template>
      <span v-html="i18n.browserNotSupportedWarning.message"></span>
    </b-modal>
  </div>
</template>

<script>
/**
 * This file is the entrypoint of the website
 * Like this we can detect if we are in Mobile or in Desktop mode
 * Then, we can choose the right Layout.
 */

import { BModal } from 'bootstrap-vue';

import Layout from '@/components/Layout.vue';
import LayoutMobile from '@/components/LayoutMobile.vue';
import TenantCustomStyle from '@/components/TenantCustomStyle.vue';
import { searchCssService } from '@/services/index';

export default {
  name: 'Main',
  components: {
    'b-modal': BModal,
    layout: Layout,
    'layout-mobile': LayoutMobile,
    'tenant-custom-style': TenantCustomStyle,
  },
  props: {
    mobile: {
      type: Boolean,
    },
  },
  data: function() {
    return {
      i18n: {
        browserNotSupportedWarning: {
          title: this.$t('browserNotSupportedWarning.title'),
          message: this.$t('browserNotSupportedWarning.message'),
        },
      },
      customStyle: undefined,
      customStyleLoaded: false,
    };
  },
  computed: {
    layout() {
      return this.mobile ? 'layout-mobile' : 'layout';
    },
    /**
     * Detect supported browsers
     * if we are using un unsupported browser, we show a warning message
     */
    supportedBrowser() {
      const supportedBrowserUserAgentPart = ['Firefox/', 'Chrome/', 'Edge/', 'Safari/'];
      const userAgent = window.navigator.userAgent;
      return supportedBrowserUserAgentPart.some((e) => userAgent.indexOf(e) !== -1);
    },
  },

  methods: {
    getCss: async function() {
      this.customStyle = await searchCssService();
      this.customStyleLoaded = true;
    },
  },

  async mounted() {
    await this.getCss();
    if (!this.supportedBrowser) {
      this.$refs['browserNotSupportedWarningModal'].show();
    }
  },
};
</script>

<style>
.warning {
  color: #ff9007;
}
</style>
